<template>
  <static-fullscreen-card>
    <template v-slot:title> ({{ data.id }}) {{ data.name }}</template>

    <template v-slot:header></template>
    <template v-slot:actions>
      <v-btn color="primary" @click="makeTasks()" :loading="isMakeTasks" :disabled="isMakeTasks || !needMakeTask" v-if="getAccess('object.taskMake')">
        <btn-title icon="fas fa-tasks">Создать задачи</btn-title>
      </v-btn>
      <a-btn-refresh @click="$refs.table.updateData()" />
      <a-btn-add @click="createNew()" v-if="getAccess('object.goodsEdit', { access: data.object_access })" />
    </template>

    <a-table-f-api
      ref="table"
      :api="url"
      :model="[
        ...model,
        {
          name: 'doc_id',
          title: 'Документ',
          type: 'selectapi',
          itemField: { value: 'id', text: 'code_doc' },
          api: 'accounting/doc/order_good',
          routeName: 'ordersGoods_view',
          preText: 'Заказ товаров №',
          isMenu: true,
        },
      ]"
      :useQuery="false"
      :defaults="{
        sort: { key: 'id', order: 'DESC' },
        filters: { object_id: id },
        paramName: 'goods.',
      }"
      @click="onClickRow($event)"
      @loadData="onLoadData($event)"
    >
    </a-table-f-api>
    <popup-menu v-model="popumMenuShow" :items="popupMenuList" :position="popupMenuPosition" @click="onClickMenu($event)" />
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <edit-dialog v-model="showEditDialog" :id="idEdit" :object_="data" />
  </static-fullscreen-card>
</template>

<script>
import { getAccess, popupMenu } from "@/components/mixings";
export default {
  mixins: [getAccess, popupMenu],
  components: {
    editDialog: () => import("@/views/dialogs/goodsDialog"),
  },
  data() {
    return {
      loading: false,
      idEdit: 0,
      showEditDialog: false,
      title: "",
      model: this.$store.getters["config/get"].models.goods.list,
      data: {},
      isMakeTasks: false,
      needMakeTask: false,
      url: "/mechti/construction-goods",
      defaults: {
        sort: { key: "id", order: "DESC" },
        filters: { object_id: this.id },
      },
      balance: {
        debit: 0,
        credit: 0,
      },
      taskUserConfig: this.$store.getters["config/get"].models.taskUserConfigGoods,
    };
  },
  created() {
    this.$root.title = "Чек-лист";
    this.fitchData();
  },
  computed: {
    editObject() {
      //console.log(this.$root.profile);

      return this.getAccess("object.edit", {
        //id: this.id,
        access: this.data.object_access.filter(a => a.user_role == 55),
        //data: this.data,
      });
    },
    id() {
      return Number(this.$route.params.id);
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        if (this.idEdit) {
          this.$refs.table.updateRowData(this.idEdit);
          this.idEdit = 0;
          //  this.$refs.table.$refs.base.$forceUpdate();
        } else this.$refs.table.updateData();
      }
    },
  },
  methods: {
    async fitchData() {
      this.loading = true;
      const d = await this.$axios.get("/mechti/objects" + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.loading = false;
    },
    onClickRow(d) {
      if (d.field?.isMenu) {
        this.showPopupMenu(d.field.name, d.row, d.event, d);
        return;
      }
      this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },

    async addTasks(task) {
      return new Promise(async (resolve, reject) => {
        let response = await this.$axios.post("/mechti/buying", task);
        let status = response.data.status == "ok";
        if (status) {
          let task_id = response.data.data.id;
          resolve(task_id);
        } else {
          reject(false);
        }
      });
    },
    onLoadData(e) {
      this.needMakeTask =
        e.filter(el => {
          return el.status == -1;
        }).length > 0;
    },
    getUserList(type) {
      const myError = message => {
        return { message, type: 1 };
      };
      if (type === undefined || type === null) type = 0;
      console.log("create list users for ", type);
      let taskUser = this.taskUserConfig.find(el => {
        return el.isFurniture == type;
      }).user_id;
      let watchers = this.taskUserConfig.find(el => {
        return el.isFurniture == type;
      }).watchers;
      let taskWatchers = [];
      try {
        if (watchers?.inRole?.length) {
          for (const role of watchers.inRole) {
            let users = this.data.object_access.filter(a => {
              return a.user_role == role /* && a.user_id !== user_id */;
            });
            if (!users.length) throw new myError("Не определен сотрудник с ролью '" + (this.$root.roles.find(r => r.value == role)?.text || "error") + "' на объекте.");

            taskWatchers = [...taskWatchers, ...users];
          }
        }
      } catch (error) {
        console.log(error);
        this.$root.$emit("show-info", {
          text: +error.type ? error.message : "Возникла ошибка....",
          type: "error",
        });
        return false;
      }
      return { user: taskUser, watchers: taskWatchers };
    },
    async makeTasks() {
      const myError = message => {
        return { message, type: 1 };
      };
      let ok = false;
      let rows = [];
      for (let row of this.$refs.table.data.filter(el => {
        return el?.checked;
      })) {
        rows.push(row.id);
      }
      console.log(rows);
      if (!rows.length) {
        this.$root.$emit("show-info", {
          text: "Ничего не выбранно!",
          type: "error",
        });
        return false;
      }
      ok = await this.$refs.confirmDialog.show({
        title: "Создание задач",
        message: [`Вы действительно хотите создать задачи ?`],
        okButton: "Да",
        cancelButton: "Нет",
      });
      if (!ok) return;

      let task_id = 0;
      const d = await this.$axios.get("/mechti/construction-goods", {
        params: { filters: { status: "-1", object_id: this.id } },
      });
      try {
        if (d.data && d.data.data) {
          let newR = d.data.data.filter(el => {
            return rows.includes(el.id);
          }); //.filter(el=>{if () });
          if (!newR.length) {
            this.$root.$emit("show-info", {
              text: "Не выбранно ни одной подходящей записи",
              type: "error",
            });
            return false;
          }
          this.isMakeTasks = true;
          for (let el of newR) {
            console.log("create task for ", el);
            let taskUsers = await this.getUserList(el.data.isFurniture);
            if (!taskUsers?.user || !taskUsers) {
              console.log("user undefined");
              this.isMakeTasks = false;
              return;
            }
            let data = {
              parent_name: "construction-goods",
              parent_id: el.id,
              type: "construction-goods",
              name: el.name,
              date_start: el.date_buy,
              date_end: el.date_buy,
              status: 200,
              is_important: 2,
              user_id: taskUsers.user,
              watchers: taskUsers.watchers,
              object_id: el.object_id,
              params: {
                parent: "construction-goods",
                parent_id: el.id,
              },
            };
            console.log("post data", data);
            let dataGoods = { id: el.id, status: -3 };
            let response = await this.$axios.post("/mechti/construction-goods", dataGoods);
            if (response.data.status == "ok") {
              response = await this.$axios.post("/mechti/buying", data);
              let status = response.data.status == "ok";
              task_id = response.data.data.id;
              if (status) {
                dataGoods = { id: el.id, task_id, status: 0 };
                response = await this.$axios.post("/mechti/construction-goods", dataGoods);
                if (response.data.status == "ok") {
                } else {
                  throw myError("Ошибка привязки товара с задачей");
                }
              } else {
                throw myError("Ошибка создания задачи");
              }
            } else {
              throw myError("Ошибка подготовки задачи");
            }
          }
          this.$root.$emit("show-info", {
            text: "Задачи созданы.",
          });
        }
      } catch (error) {
        console.log(error);
        this.$root.$emit("show-info", {
          text: +error.type ? error.message : "Возникла ошибка....",
          type: "error",
        });
        if (task_id) {
          await this.$axios({
            method: "delete",
            url: "/mechti/buying" + "/" + task_id,
          });
        }
      }
      this.$refs.table.updateData();
      this.isMakeTasks = false;
    },
  },
};
</script>
